export default __webpack_public_path__ + "static/article-why-you-should-spend-valentines-day-alone-5bf2670147eeb4b17872081505e09875.jpg";